<template>
  <component
  :is="typeComponent"
  :column="item"
  :scope="scope"
  @on-edit="handleEdit" />
</template>

<script>
import _ from 'lodash'
const commonPath = './components/'
const dynamicLoad = () => {
  return {
    IInput: () => import(`${commonPath}Input`),
    ICascader: () => import(`${commonPath}Cascader`),
    ICheckbox: () => import(`${commonPath}Checkbox`),
    IDate: () => import(`${commonPath}Date`),
    IDaterange: () => import(`${commonPath}Daterange`),
    IDatetime: () => import(`${commonPath}Datetime`),
    IDatetimerange: () => import(`${commonPath}Datetimerange`),
    IDivider: () => import(`${commonPath}Divider`),
    IMonth: () => import(`${commonPath}Month`),
    INumber: () => import(`${commonPath}Number`),
    IPassword: () => import(`${commonPath}Password`),
    IRadio: () => import(`${commonPath}Radio`),
    ISelect: () => import(`${commonPath}Select`),
    ITextarea: () => import(`${commonPath}Textarea`),
    ITime: () => import(`${commonPath}Time`),
    ITimerange: () => import(`${commonPath}Timerange`),
    ITree: () => import(`${commonPath}Tree`),
    IUpload: () => import(`${commonPath}Upload`),
    IWeek: () => import(`${commonPath}Week`),
    IYear: () => import(`${commonPath}Year`),
    ICalculator: () => import(`${commonPath}Calculator`),
    IPopUpWindow: () => import(`${commonPath}PopUpWindow`),
    IFlowUserChoose: () => import(`${commonPath}FlowUserChoose`),
    IWebMap: () => import(`${commonPath}WebMap`),
    IOffice: () => import(`${commonPath}Office`),
    ILicensePlate: () => import(`${commonPath}LicensePlate`),
  }
}
export default {
  props: ['item', 'scope'],
  computed: {
    typeComponent() {
      const {
        type
      } = this.item
      switch (type) {
        case 'caption':
          return 'caption-ext'
        case 'calculateFormula':
          return 'ICalculator'
        case 'hyperLink':
          return 'hyper-link'
        default:
          return `I${_.upperFirst(type)}`
      }
    }
  },
  components: dynamicLoad(),
  methods: {
    handleEdit(val, key, index) {
      this.$emit('on-edit', val, key, index, this.item)
    }
  }
}
</script>
